/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cookies from 'universal-cookie';

function Logout() {
  let apiUrl = "";
  let apiParams = {};
  const cookies = new Cookies();
  let location = useLocation();
  let access_token = cookies.get("auth_access_token");
  let auth_token = cookies.get("auth_token");
  let auth_refresh_token = cookies.get("auth_refresh_token");
  cookies.remove("auth_access_token", { path: '/' });
  cookies.remove("auth_token", { path: '/' });
  cookies.remove("auth_refresh_token", { path: '/' });
  cookies.remove("userInfo", { path: '/' });

  apiUrl = "/Logout";
  apiParams = {
    "access_token": access_token,
    "auth_token": auth_token,
    "auth_refresh_token": auth_refresh_token
  };

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(apiParams)
  };
  useEffect(() => {
    fetch("/api" + apiUrl, requestOptions)
      .then(res => res.json())
      .then((result) => {
        if (result.redirectUri !== undefined && result.redirectUri !== "" && result.redirectUri != null)
          window.location.replace(result.redirectUri);
        else
          window.location.replace("/");

      }).catch(err => {
        throw new Error(err)
      })
  }, [location]);

  return (
    <>

    </>
  );
}

export default Logout;